const colorMapBotonBrillante = {
  red: {
    bg: "bg-red-700",
    border: "border-red-900",
    hoverBg: "hover:bg-red-500",
    hoverBorder: "hover:border-red-100",
    hoverShadow: "hover:shadow-red-500/50",
  },
  yellow: {
    bg: "bg-yellow-700",
    border: "border-yellow-900",
    hoverBg: "hover:bg-yellow-500",
    hoverBorder: "hover:border-yellow-100",
    hoverShadow: "hover:shadow-yellow-500/50",
  },
  green: {
    bg: "bg-green-700",
    border: "border-green-900",
    hoverBg: "hover:bg-green-500",
    hoverBorder: "hover:border-green-100",
    hoverShadow: "hover:shadow-green-500/50",
  },
  blue: {
    bg: "bg-blue-700",
    border: "border-blue-900",
    hoverBg: "hover:bg-blue-500",
    hoverBorder: "hover:border-blue-100",
    hoverShadow: "hover:shadow-blue-500/50",
  },
  indigo: {
    bg: "bg-indigo-700",
    border: "border-indigo-900",
    hoverBg: "hover:bg-indigo-500",
    hoverBorder: "hover:border-indigo-100",
    hoverShadow: "hover:shadow-indigo-500/50",
  },
  purple: {
    bg: "bg-purple-700",
    border: "border-purple-900",
    hoverBg: "hover:bg-purple-500",
    hoverBorder: "hover:border-purple-100",
    hoverShadow: "hover:shadow-purple-500/50",
  },
  pink: {
    bg: "bg-pink-700",
    border: "border-pink-900",
    hoverBg: "hover:bg-pink-500",
    hoverBorder: "hover:border-pink-100",
    hoverShadow: "hover:shadow-pink-500/50",
  },
  rose: {
    bg: "bg-rose-700",
    border: "border-rose-900",
    hoverBg: "hover:bg-rose-500",
    hoverBorder: "hover:border-rose-100",
    hoverShadow: "hover:shadow-rose-500/50",
  },
  orange: {
    bg: "bg-orange-700",
    border: "border-orange-900",
    hoverBg: "hover:bg-orange-500",
    hoverBorder: "hover:border-orange-100",
    hoverShadow: "hover:shadow-orange-500/50",
  },
  amber: {
    bg: "bg-amber-700",
    border: "border-amber-900",
    hoverBg: "hover:bg-amber-500",
    hoverBorder: "hover:border-amber-100",
    hoverShadow: "hover:shadow-amber-500/50",
  },
  lime: {
    bg: "bg-lime-700",
    border: "border-lime-900",
    hoverBg: "hover:bg-lime-500",
    hoverBorder: "hover:border-lime-100",
    hoverShadow: "hover:shadow-lime-500/50",
  },
  emerald: {
    bg: "bg-emerald-700",
    border: "border-emerald-900",
    hoverBg: "hover:bg-emerald-500",
    hoverBorder: "hover:border-emerald-100",
    hoverShadow: "hover:shadow-emerald-500/50",
  },
  teal: {
    bg: "bg-teal-700",
    border: "border-teal-900",
    hoverBg: "hover:bg-teal-500",
    hoverBorder: "hover:border-teal-100",
    hoverShadow: "hover:shadow-teal-500/50",
  },
  cyan: {
    bg: "bg-cyan-700",
    border: "border-cyan-900",
    hoverBg: "hover:bg-cyan-500",
    hoverBorder: "hover:border-cyan-100",
    hoverShadow: "hover:shadow-cyan-500/50",
  },
  sky: {
    bg: "bg-sky-700",
    border: "border-sky-900",
    hoverBg: "hover:bg-sky-500",
    hoverBorder: "hover:border-sky-100",
    hoverShadow: "hover:shadow-sky-500/50",
  },
  violet: {
    bg: "bg-violet-700",
    border: "border-violet-900",
    hoverBg: "hover:bg-violet-500",
    hoverBorder: "hover:border-violet-100",
    hoverShadow: "hover:shadow-violet-500/50",
  },
  fuchsia: {
    bg: "bg-fuchsia-700",
    border: "border-fuchsia-900",
    hoverBg: "hover:bg-fuchsia-500",
    hoverBorder: "hover:border-fuchsia-100",
    hoverShadow: "hover:shadow-fuchsia-500/50",
  },
  neutral: {
    bg: "bg-neutral-700",
    border: "border-neutral-900",
    hoverBg: "hover:bg-neutral-500",
    hoverBorder: "hover:border-neutral-100",
    hoverShadow: "hover:shadow-neutral-500/50",
  },
  stone: {
    bg: "bg-stone-700",
    border: "border-stone-900",
    hoverBg: "hover:bg-stone-500",
    hoverBorder: "hover:border-stone-100",
    hoverShadow: "hover:shadow-stone-500/50",
  },
  gray: {
    bg: "bg-gray-700",
    border: "border-gray-900",
    hoverBg: "hover:bg-gray-500",
    hoverBorder: "hover:border-gray-100",
    hoverShadow: "hover:shadow-gray-500/50",
  },
  zinc: {
    bg: "bg-zinc-700",
    border: "border-zinc-900",
    hoverBg: "hover:bg-zinc-500",
    hoverBorder: "hover:border-zinc-100",
    hoverShadow: "hover:shadow-zinc-500/50",
  },
  slate: {
    bg: "bg-slate-700",
    border: "border-slate-900",
    hoverBg: "hover:bg-slate-500",
    hoverBorder: "hover:border-slate-100",
    hoverShadow: "hover:shadow-slate-500/50",
  },
  black: {
    bg: "bg-black",
    border: "border-black",
    hoverBg: "hover:bg-gray-900",
    hoverBorder: "hover:border-gray-100",
    hoverShadow: "hover:shadow-gray-900/50",
  },

  // Estilos para el botón actual
  red_current: {
    bg: "bg-red-500",
    border: "border-red-100",
    shadow: "shadow-red-500/50",
  },
  yellow_current: {
    bg: "bg-yellow-500",
    border: "border-yellow-100",
    shadow: "shadow-yellow-500/50",
  },
  green_current: {
    bg: "bg-green-500",
    border: "border-green-100",
    shadow: "shadow-green-500/50",
  },
  blue_current: {
    bg: "bg-blue-500",
    border: "border-blue-100",
    shadow: "shadow-blue-500/50",
  },
  indigo_current: {
    bg: "bg-indigo-500",
    border: "border-indigo-100",
    shadow: "shadow-indigo-500/50",
  },
  purple_current: {
    bg: "bg-purple-500",
    border: "border-purple-100",
    shadow: "shadow-purple-500/50",
  },
  pink_current: {
    bg: "bg-pink-500",
    border: "border-pink-100",
    shadow: "shadow-pink-500/50",
  },
  rose_current: {
    bg: "bg-rose-500",
    border: "border-rose-100",
    shadow: "shadow-rose-500/50",
  },
  orange_current: {
    bg: "bg-orange-500",
    border: "border-orange-100",
    shadow: "shadow-orange-500/50",
  },
  amber_current: {
    bg: "bg-amber-500",
    border: "border-amber-100",
    shadow: "shadow-amber-500/50",
  },
  lime_current: {
    bg: "bg-lime-500",
    border: "border-lime-100",
    shadow: "shadow-lime-500/50",
  },
  emerald_current: {
    bg: "bg-emerald-500",
    border: "border-emerald-100",
    shadow: "shadow-emerald-500/50",
  },
  teal_current: {
    bg: "bg-teal-500",
    border: "border-teal-100",
    shadow: "shadow-teal-500/50",
  },
  cyan_current: {
    bg: "bg-cyan-500",
    border: "border-cyan-100",
    shadow: "shadow-cyan-500/50",
  },
  sky_current: {
    bg: "bg-sky-500",
    border: "border-sky-100",
    shadow: "shadow-sky-500/50",
  },
  violet_current: {
    bg: "bg-violet-500",
    border: "border-violet-100",
    shadow: "shadow-violet-500/50",
  },
  fuchsia_current: {
    bg: "bg-fuchsia-500",
    border: "border-fuchsia-100",
    shadow: "shadow-fuchsia-500/50",
  },
  neutral_current: {
    bg: "bg-neutral-500",
    border: "border-neutral-100",
    shadow: "shadow-neutral-500/50",
  },
  stone_current: {
    bg: "bg-stone-500",
    border: "border-stone-100",
    shadow: "shadow-stone-500/50",
  },
  gray_current: {
    bg: "bg-gray-500",
    border: "border-gray-100",
    shadow: "shadow-gray-500/50",
  },
  zinc_current: {
    bg: "bg-zinc-500",
    border: "border-zinc-100",
    shadow: "shadow-zinc-500/50",
  },
  slate_current: {
    bg: "bg-slate-500",
    border: "border-slate-100",
    shadow: "shadow-slate-500/50",
  },
  black_current: {
    bg: "bg-gray-900", // Cambiar a un tono más claro
    border: "border-gray-100",
    shadow: "shadow-gray-500/50",
  },
};

export default colorMapBotonBrillante;
